import { useQuery } from '@tanstack/react-query';

export interface LogHygieneSample {
  correlation_coverage: number;
  legacy_event_count: number;
  redact_hits_last_5min: number;
  total_events: number;
}

export function useLogHygiene() {
  return useQuery<LogHygieneSample>({
    queryKey: ['log-hygiene'],
    queryFn: async () => {
      const r = await fetch('/api/admin/log-hygiene/latest');
      if (!r.ok) throw new Error('failed');
      return r.json() as Promise<LogHygieneSample>;
    },
    refetchInterval: 60_000,
  });
}
